<template>
    <FormContainer>
        <Label :label="'Media Links'" />
        <div v-for="(media, index) in medias" :key="index" class="flex flex-row gap-2 items-center mb-2">
            <SelectOption
                v-model="medias[index].type"
                :options="mediaTypes"
                :disabled="disabled"
            />
            <Input
                v-model="medias[index].preview"
                type="url"
                placeholder="Enter media URL"
                @input="updateType(index, $event)"
                :disabled="disabled"
            />
            <Tooltip v-if="!disabled" :text="'Remove media link'" :position="'top'">
                <MinusCircleIcon @click="removeMedia(index)" class="w-6 h-6 text-red-500 cursor-pointer hover:text-red-600" />
            </Tooltip>
        </div>
        <div v-if="!disabled" class="w-10">
            <Tooltip :text="'Add media link'" :position="'top'">
                <PlusCircleIcon @click="addMedia" class="w-6 h-6 text-green-500 cursor-pointer hover:text-green-600 mt-2" />
            </Tooltip>
        </div>
    </FormContainer>
</template>
<script setup>
import {ref, defineProps, defineEmits, defineExpose, onMounted, watch} from 'vue';
import SelectOption from '@/components/form/SelectOption.vue';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: {
        type: Array,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const mediaTypes = ['youtube', 'spotify', 'audio', 'video'];
const medias = ref(props.modelValue);
onMounted(() => {
    medias.value = props.modelValue;
});

watch(() => props.modelValue, (newVal) => {
    medias.value = newVal;
});

const addMedia = () => {
    medias.value.push({ type: 'youtube', preview: '' });
    emit('update:modelValue', medias.value);
}

const removeMedia = (index) => {
    medias.value.splice(index, 1);
}

const updateType = (index, event) => {
    if (event.target.value.includes('youtube')) {
        medias.value[index].type = 'youtube';
    } else if (event.target.value.includes('spotify')) {
        medias.value[index].type = 'spotify';
    } 
    emit('update:modelValue', medias.value);
}

defineExpose({
    addMedia,
    removeMedia
});
</script>